<template>
  <div>
    <MainNavigation />
    <ConfirmationModal />
    <CreateFolderModal />
    <UploadFilesModal />
    <UploadVideosModal />
    <FilePreviewModal />
    <UploadUrlModal />
    <FilePickerModal />
    <ChangeFileModal />
    <DevicePickerModal />
    <PlaylistPickerModal />
    <PlaylistUsageModal />
    <router-view />
  </div>
</template>

<script>

import ConfirmationModal from '@/components/ConfirmationModal.vue';
import MainNavigation from '@/components/MainNavigation.vue';
import ChangeFileModal from '@/components/modals/ChangeFileModal.vue';
import CreateFolderModal from '@/components/modals/CreateFolderModal.vue';
import DevicePickerModal from '@/components/modals/DevicePickerModal.vue';
import FilePickerModal from '@/components/modals/FilePickerModal.vue';
import FilePreviewModal from '@/components/modals/FilePreviewModal.vue';
import PlaylistPickerModal from '@/components/modals/PlaylistPickerModal.vue';
import PlaylistUsageModal from '@/components/modals/PlaylistUsageModal.vue';
import UploadFilesModal from '@/components/modals/UploadFilesModal.vue';
import UploadUrlModal from '@/components/modals/UploadUrlModal.vue';
import UploadVideosModal from '@/components/modals/UploadVideosModal.vue';

export default {
  name: 'AdminPanel',
  components: {
    MainNavigation,
    ConfirmationModal,
    CreateFolderModal,
    UploadFilesModal,
    UploadVideosModal,
    FilePreviewModal,
    UploadUrlModal,
    FilePickerModal,
    ChangeFileModal,
    DevicePickerModal,
    PlaylistPickerModal,
    PlaylistUsageModal,
  },
};
</script>
